import React, { useState } from 'react';
import { Modal, Form, Input, InputNumber, Button, message, Result } from 'antd';
import { submitEtimsInvoice } from '../api';

const EtimsInvoiceModal = ({ open, onClose, farmId, onSuccess }) => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const [result, setResult] = useState(null); // holds success response for display

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setSubmitting(true);
            const res = await submitEtimsInvoice({
                farmId,
                amount: values.amount,
                description: values.description,
                taxRate: values.taxRate
            });
            setResult(res.result);
            message.success('Invoice submitted to eTIMS');
            onSuccess?.();
        } catch (err) {
            message.error(err.response?.data?.error || 'Failed to submit invoice to eTIMS');
        } finally {
            setSubmitting(false);
        }
    };

    const handleClose = () => {
        form.resetFields();
        setResult(null);
        onClose();
    };

    return (
        <Modal title="Generate eTIMS Invoice" open={open} onCancel={handleClose} footer={null} destroyOnClose>
            {!result ? (
                <Form form={form} layout="vertical" initialValues={{ taxRate: 16 }}>
                    <Form.Item name="description" label="Item / Service Description" rules={[{ required: true }]}>
                        <Input placeholder="e.g. Farm subscription - August 2026" />
                    </Form.Item>
                    <Form.Item name="amount" label="Amount (KES)" rules={[{ required: true }]}>
                        <InputNumber min={1} style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item name="taxRate" label="Tax Rate (%)" rules={[{ required: true }]}>
                        <InputNumber min={0} max={100} style={{ width: '100%' }} />
                    </Form.Item>
                    <Button type="primary" block onClick={handleSubmit} loading={submitting}>
                        Submit to eTIMS
                    </Button>
                </Form>
            ) : (
                <Result
                    status="success"
                    title="Invoice Submitted"
                    subTitle={`Fiscal Document #: ${result.fiscalDocumentNumber || 'Pending'}`}
                    extra={[
                        result.qrCodeUrl && (
                            <img key="qr" src={result.qrCodeUrl} alt="eTIMS QR Code" style={{ maxWidth: 150 }} />
                        ),
                        <Button key="close" type="primary" onClick={handleClose}>Done</Button>
                    ]}
                />
            )}
        </Modal>
    );
};

export default EtimsInvoiceModal;